// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__FMeXu","card":"LoginPage_card__vQbF2","cardBody":"LoginPage_cardBody__LB-Ce","cardMsg":"LoginPage_cardMsg__UnlKx"};